import { Inject, Injectable, Injector } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import {
  ClienteProxiInatResponse,
  ClienteResponse,
  PaginatorResponse,
} from '../models/cliente.model';
import { VendedoresResponse } from '../models/orcamento.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import {
  ENVIRONMENT_TOKEN,
  Environment,
} from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class ClienteApiService extends UtilsBaseApiService<ClienteApiService> {
  readonly VENDEDORES_EXTENSION = 'vendedores';
  readonly GET_CLIENTES_EXTENSION = 'getClientes';
  readonly LIMITE_EXTENSION = 'limite';
  readonly GET_CUSTOMERS_ACTIVE_EXTENSION = 'clientesAtivos';
  readonly GET_CUSTOMERS_INACTIVE_EXTENSION = 'clientesInativos';
  readonly GET_CUSTOMERS_NEXT_INACTIVE_EXTENSION = 'clientesProxiInat';
  clientes!: PaginatorResponse<ClienteResponse>;
  selectOptions!: PaginatorResponse<ClienteResponse>;
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
  ) {
    super('cliente', injector, environment.BASE_API_URL);
  }

  getVendedores(id: number): Observable<VendedoresResponse[]> {
    return this.httpClient.get<VendedoresResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.VENDEDORES_EXTENSION}/${id}`,
    );
  }
  getClientes(nome: string = '') {
    if (!nome && this.clientes) {
      return of(this.clientes);
    }
    return this.httpClient
      .post<PaginatorResponse<ClienteResponse>>(
        `${this.BASE_URL}${this.CONTEXT}/${this.GET_CLIENTES_EXTENSION}`,
        {
          atacarejo: 0,
          codUsur: '0',
          index: 0,
          length: 30,
          nome: nome,
          seqCliente: 4,
        },
      )
      .pipe(
        tap((response) => {
          if (!nome && !this.clientes) {
            this.clientes = response;
          }

          this.clientes = response;
        }),
      );
  }

  getClienteForOptions(nome: string) {
    return this.getClientes(nome).pipe(
      map((response) => {
        this.clientes = response;
        return response.data;
      }),
    );
  }

  getLimite(userID: string | number, clienteID: string | number) {
    return this.httpClient.get<number>(
      `${this.BASE_URL}${this.CONTEXT}/${this.LIMITE_EXTENSION}/${userID}/${clienteID}`,
    );
  }

  getClienteById(id: string) {
    return this.httpClient.get<ClienteResponse>(
      `${this.BASE_URL}${this.CONTEXT}/${this.GET_CLIENTES_EXTENSION}/${id}`,
    );
  }

  getNextInactive(id: number, index = 1, length = 50) {
    const queryString = this.getQueryString({ idFuncionario: id, index, length });
    return this.httpClient.get<
      ClienteProxiInatResponse[] | PaginatorResponse<ClienteProxiInatResponse>
    >(
      `${this.BASE_URL}${this.CONTEXT}/${this.GET_CUSTOMERS_NEXT_INACTIVE_EXTENSION}?${queryString}`,
    );
  }

  getActive(id: number, index = 1, length = 50) {
    const queryString = this.getQueryString({ idFuncionario: id, index, length });
    return this.httpClient.get<
      ClienteProxiInatResponse[] | PaginatorResponse<ClienteProxiInatResponse>
    >(
      `${this.BASE_URL}${this.CONTEXT}/${this.GET_CUSTOMERS_ACTIVE_EXTENSION}?${queryString}`,
    );
  }

  getInactive(id: number, index = 1, length = 50) {
    const queryString = this.getQueryString({ idFuncionario: id, index, length });
    return this.httpClient.get<
      ClienteProxiInatResponse[] | PaginatorResponse<ClienteProxiInatResponse>
    >(
      `${this.BASE_URL}${this.CONTEXT}/${this.GET_CUSTOMERS_INACTIVE_EXTENSION}?${queryString}`,
    );
  }
}
